// TODO-KPI-116: setin 0069 sonrası değerli kategori satırları (metrik kimlikleri) — Veri Yönetimi
// uyarısı için. Hata sessiz (uyarı yardımcıdır; ağaç yine çalışır). `reloadKey` değişince yeniden okur.

import { useEffect, useState } from "react";
import { getKpiLegacyCategoryValues } from "../api/kpi";

const EMPTY: ReadonlySet<string> = new Set();

export function useLegacyCategoryValues(
  setId: string | null,
  reloadKey: unknown,
): ReadonlySet<string> {
  const [ids, setIds] = useState<ReadonlySet<string>>(EMPTY);
  useEffect(() => {
    if (!setId) {
      setIds(EMPTY);
      return;
    }
    let alive = true;
    getKpiLegacyCategoryValues(setId)
      .then((r) => {
        if (alive) setIds(r.metricIds.length > 0 ? new Set(r.metricIds) : EMPTY);
      })
      .catch(() => {
        if (alive) setIds(EMPTY);
      });
    return () => {
      alive = false;
    };
  }, [setId, reloadKey]);
  return ids;
}
